import { render, staticRenderFns } from "./info-more.vue?vue&type=template&id=3e16c724&scoped=true&"
import script from "./info-more.vue?vue&type=script&lang=js&"
export * from "./info-more.vue?vue&type=script&lang=js&"
import style0 from "./info-more.vue?vue&type=style&index=0&id=3e16c724&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e16c724",
  null
  
)

export default component.exports